import { CreateRoomResourceForm } from "../../resourcesTypes"

type FieldKey = keyof CreateRoomResourceForm

export enum TabsOrder {
    GENERAL,
    TABLE_ARRANGEMENTS,
    AVAILABILITY,
    ACCESS_CONTROL,
}

export const fieldTabMap: { [field in FieldKey]: TabsOrder } = {
    isActive: TabsOrder.GENERAL,
    reference: TabsOrder.GENERAL,
    name: TabsOrder.GENERAL,
    image: TabsOrder.GENERAL,
    description: TabsOrder.GENERAL,
    email: TabsOrder.GENERAL,
    buffer: TabsOrder.GENERAL,
    color: TabsOrder.GENERAL,
    roomDetails: TabsOrder.GENERAL,
    accessControl: TabsOrder.TABLE_ARRANGEMENTS,
    closingTimes: TabsOrder.AVAILABILITY,
    notifications: TabsOrder.GENERAL,
    tags: TabsOrder.GENERAL,
    bookingTime: TabsOrder.AVAILABILITY,
    inService: TabsOrder.GENERAL,
    closingTimesDaily: TabsOrder.AVAILABILITY,
    isClosingTimes: TabsOrder.AVAILABILITY,
    isBookingTime: TabsOrder.AVAILABILITY,
    integrationType: TabsOrder.GENERAL,
    integrationEmailAddress: TabsOrder.GENERAL,
}
